import { createUserAsyncResponse } from "./types";
import * as userActions from "./users.actions";
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../../interfaces/Response";
import { apiPost, API_URL_USER, retrieveToken } from "../../../helpers/api";

export function* createUser(action: ReturnType<typeof userActions.createUserAsync.request>) {
  try {
    const token: string = yield retrieveToken();
    const result: Response = yield call(apiPost, API_URL_USER.CREATE_USER, token, action.payload);
    if (result.status === 200) {
      const parsed: createUserAsyncResponse = yield call(result.json.bind(result));
      yield put(userActions.createUserAsync.success(parsed));
      return;
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(userActions.createUserAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      status: 500,
      errors: {},
      message: 'Terjadi kesalahan pada server'
    }
    yield put(userActions.createUserAsync.failure(parsed));
  }
}

export default function* usersSagaCreateUser() {
  yield takeEvery(userActions.createUserAsync.request, createUser);
}
